function CollapseSidePanelIcon() {
  return (
    <svg width='11' height='10' viewBox='0 0 11 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='angle-small-right 1' clipPath='url(#clip0_4942_13674)'>
        <path
          id='Vector'
          d='M6.42334 3.5041L9.66334 0.264103C9.79559 0.132632 9.9745 0.0588379 10.161 0.0588379C10.3475 0.0588379 10.5264 0.132632 10.6586 0.264103C10.7248 0.329724 10.7773 0.407795 10.8131 0.493814C10.849 0.579832 10.8674 0.672095 10.8674 0.765279C10.8674 0.858464 10.849 0.950727 10.8131 1.03675C10.7773 1.12276 10.7248 1.20083 10.6586 1.26646L7.41157 4.4994C7.34541 4.56502 7.2929 4.64309 7.25706 4.72911C7.22123 4.81512 7.20277 4.90739 7.20277 5.00057C7.20277 5.09376 7.22123 5.18602 7.25706 5.27204C7.2929 5.35806 7.34541 5.43613 7.41157 5.50175L10.6586 8.73469C10.7916 8.86667 10.8666 9.04605 10.8673 9.23337C10.8679 9.42068 10.7941 9.60059 10.6622 9.73351C10.5302 9.86643 10.3508 9.94148 10.1635 9.94214C9.97617 9.9428 9.79626 9.86902 9.66334 9.73704L6.42334 6.49704C6.02677 6.09998 5.80402 5.56175 5.80402 5.00057C5.80402 4.43939 6.02677 3.90116 6.42334 3.5041Z'
          fill='#5A6675'
        />
        <path
          id='Vector_2'
          d='M1.48212 3.5041L4.72212 0.264103C4.85437 0.132632 5.03328 0.0588379 5.21976 0.0588379C5.40625 0.0588379 5.58515 0.132632 5.71741 0.264103C5.78357 0.329724 5.83608 0.407795 5.87192 0.493814C5.90776 0.579832 5.92621 0.672095 5.92621 0.765279C5.92621 0.858464 5.90776 0.950727 5.87192 1.03675C5.83608 1.12276 5.78357 1.20083 5.71741 1.26646L2.47035 4.4994C2.40419 4.56502 2.35168 4.64309 2.31584 4.72911C2.28 4.81512 2.26155 4.90739 2.26155 5.00057C2.26155 5.09376 2.28 5.18602 2.31584 5.27204C2.35168 5.35806 2.40419 5.43613 2.47035 5.50175L5.71741 8.73469C5.85033 8.86667 5.92538 9.04605 5.92604 9.23337C5.9267 9.42068 5.85292 9.60059 5.72094 9.73351C5.58895 9.86643 5.40957 9.94148 5.22226 9.94214C5.03494 9.9428 4.85504 9.86902 4.72212 9.73704L1.48212 6.49704C1.08555 6.09998 0.862802 5.56175 0.862802 5.00057C0.862802 4.43939 1.08555 3.90116 1.48212 3.5041Z'
          fill='#5A6675'
        />
      </g>
      <defs>
        <clipPath id='clip0_4942_13674'>
          <rect
            width='10.5882'
            height='9.88331'
            fill='white'
            transform='matrix(-1 0 0 1 10.9412 0.0588379)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CollapseSidePanelIcon;
